import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { ProdutoNFCeDto } from "src/pages/Privada/Fiscal/NFCe/NFCe.Dto";
import { FloatInput } from "src/componentes";
import { useForm } from "react-hook-form";
import { useEffect, useMemo } from "react";

export interface NFeCadastroItemModalPropriedadesProps {
  show: boolean;
  onCancel: () => void;
  onDelete: (value: ProdutoNFCeDto) => void;
  onConfirm: (value: ProdutoNFCeDto) => void;
  produto: ProdutoNFCeDto | undefined;
}

interface ItemPropriedadesFormData {
  quantidade: string;
  valorUnitario: string;
}

const parseDecimalValue = (val?: string): number => {
  if (!val) return 0;
  const clean = val.replace(/\./g, "").replace(",", ".");
  const num = parseFloat(clean);
  return isNaN(num) ? 0 : num;
};

export const NFeCadastroItemModalPropriedadesView = (
  props: NFeCadastroItemModalPropriedadesProps
) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    formState: { errors },
  } = useForm<ItemPropriedadesFormData>();

  useEffect(() => {
    if (props.show && props.produto) {
      const qtd =
        props.produto.quantidadeComercial != null
          ? props.produto.quantidadeComercial.toString().replace(".", ",")
          : "1";
      const vlr =
        props.produto.valorUnitarioComercial != null
          ? props.produto.valorUnitarioComercial.toFixed(2).replace(".", ",")
          : "0,00";

      setValue("quantidade", qtd);
      setValue("valorUnitario", vlr);

      const timer = setTimeout(() => {
        setValue("quantidade", qtd);
        setValue("valorUnitario", vlr);
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [props.show, props.produto, setValue]);

  const watchQuantidade = watch("quantidade");
  const watchValorUnitario = watch("valorUnitario");

  const totalCalculado = useMemo(() => {
    const qtd = parseDecimalValue(watchQuantidade);
    const vlr = parseDecimalValue(watchValorUnitario);
    return qtd * vlr;
  }, [watchQuantidade, watchValorUnitario]);

  const onDeleteHandler = () => {
    if (props.produto) {
      props.onCancel();
      props.onDelete(props.produto);
    }
  };

  const onConfirmHandler = (data: ItemPropriedadesFormData) => {
    if (!props.produto) return;

    const quantidade = parseDecimalValue(data.quantidade);
    const valorUnitario = parseDecimalValue(data.valorUnitario);

    if (quantidade <= 0) {
      setError("quantidade", {
        type: "manual",
        message: "Quantidade deve ser maior que zero",
      });
      return;
    }

    const updatedItem: ProdutoNFCeDto = {
      ...props.produto,
      quantidadeComercial: quantidade,
      quantidadeTributavel: quantidade,
      valorUnitarioComercial: valorUnitario,
      valorUnitarioTributavel: valorUnitario,
      valorTotal: Number((quantidade * valorUnitario).toFixed(2)),
    };

    props.onConfirm(updatedItem);
  };

  return (
    <Modal show={props.show} onHide={props.onCancel} centered>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit(onConfirmHandler)(e);
        }}
      >
        <Modal.Body>
          <Row className="mb-3">
            <Col xs={12} className="fw-bold">
              {props.produto?.nome}{" "}
              <span className="text-muted fw-normal">
                [{props.produto?.codigoProduto}]
              </span>
            </Col>
          </Row>
          <Row className="g-3">
            <Col xs={12} lg={6}>
              <FloatInput
                label="Quantidade"
                inputMask="decimal3"
                registerField={register("quantidade")}
                errorsMessage={errors.quantidade}
                textAlign="center"
              />
            </Col>
            <Col xs={12} lg={6}>
              <FloatInput
                label="Valor Unitário"
                inputMask="decimal2"
                registerField={register("valorUnitario")}
                errorsMessage={errors.valorUnitario}
                textAlign="center"
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={12} className="text-end">
              <span className="text-muted me-2">Valor Total:</span>
              <span className="fs-5 fw-bold">
                {totalCalculado.toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button
            variant="outline-danger"
            className="messagebox-btn-cancel"
            onClick={onDeleteHandler}
            type="button"
          >
            Excluir
          </Button>
          <div className="d-flex gap-2">
            <Button
              variant="outline-secondary"
              onClick={props.onCancel}
              type="button"
            >
              Voltar
            </Button>
            <Button variant="outline-primary" type="submit">
              Confirmar
            </Button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
